// Helpers puros usados pelos sub-componentes de Atividades.

/** Extrai @emails de um texto livre. Retorna lista única em minúsculas. */
export function extrairMencoes(t: string): string[] {
  const re = /@([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
  const set = new Set<string>();
  let m;
  while ((m = re.exec(t)) !== null) set.add(m[1].toLowerCase());
  return Array.from(set);
}
